import { render, staticRenderFns } from "./ExpressionOfInterestForm.vue?vue&type=template&id=322bb3a4&"
import script from "./ExpressionOfInterestForm.vue?vue&type=script&lang=ts&"
export * from "./ExpressionOfInterestForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VForm,VTab,VTabs})
